<template>
  <div id="verify-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        config-module="970"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItemsAuto"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--取回-->
          <el-button v-show="$checkPermission(['button_SingleRelease_getBack'])" no="1" :disabled="getBackFlag" type="primary" @click="btnGetBackEventHandler">{{ $t('CargoMsg.Cargo_GetBack') }}</el-button>
          <!--撤销取回-->
          <el-button v-show="$checkPermission(['button_SingleRelease_getBack'])" no="2" :disabled="cancelGetBackFlag" type="primary" @click="btnCancelGetBackEventHandler">{{ $t('CargoMsg.Cargo_CancelGetBack') }}</el-button>
          <!--接收-->
          <el-button v-show="$checkPermission(['button_SingleRelease_receive'])" no="3" type="primary" @click="btnReceivedEventHandler">{{ $t('CargoMsg.Cargo_Receive') }}</el-button>
          <!--撤销接收-->
          <el-button v-show="$checkPermission(['button_SingleRelease_receive'])" no="4" type="primary" @click="btnCancelReceivedEventHandler">{{ $t('CargoMsg.Cargo_RevocationOfReceipt') }}</el-button>
          <!--认领-->
          <el-button v-show="$checkPermission(['button_SingleRelease_claim'])" no="5" type="primary" @click="btnClaimEventHandler">{{ $t('CargoMsg.Cargo_Claim') }}</el-button>
          <!--撤销认领-->
          <el-button v-show="$checkPermission(['button_SingleRelease_claim'])" no="6" type="primary" @click="btnCancelClaimEventHandler">{{ $t('CargoMsg.Cargo_RevokeClaim') }}</el-button>
          <!--改单-->
          <el-button v-show="$checkPermission(['button_SingleRelease_ChangeOrder'])" no="7" type="primary" @click="btnChangeOrderEventHandler">{{ $t('SeaExport.change') }}</el-button>
          <!--放单-->
          <el-button v-show="$checkPermission(['button_SingleRelease_singleRelease'])" no="8" type="primary" @click="btnFdEventHandler">{{ $t('CargoMsg.Cargo_Releasing') }}</el-button>
          <!--撤销放单-->
          <el-button v-show="$checkPermission(['button_SingleRelease_singleRelease'])" no="9" type="primary" @click="btnCancelFdEventHandler">{{ $t('SeaExport.CancelReleasing') }}</el-button>
          <!--打印-->
          <el-button no="10" type="primary" @click="btnPrintEventHandler">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
          <!--提单日志-->
          <el-button no="11" type="primary" @click="btnStatusHistoryEventHandler">{{ $t('SeaExport.BillingOfLadingRecordManager') }}</el-button>
          <!-- 申请放单 -->
          <el-button v-show="$checkPermission(['button_SingleRelease_requestReleaseMBL'])" no="12" type="primary" @click="btnRequestReleaseEventHandler">{{ $t('SeaExport.ApplyForARelease') }}</el-button>
          <!-- 取消申请放单 -->
          <el-button v-show="$checkPermission(['button_SingleRelease_requestReleaseMBL'])" no="13" type="primary" @click="btnCancelRequestReleaseEventHandler">{{ $t('SeaExport.WithdrawTheRequestForRelease') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="970002"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          style="width: 100%; min-height: 300px"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="970001"
          :total="total"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQueryByPage"
        />
      </div>
    </div>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :printed-callback="printedCallback"
    />
    <!-- 提单日志管理-->
    <status-change-history-dialog
      :visible.sync="statusChangeHistoryDialog.visible"
      :business-data-id="statusChangeHistoryDialog.uuid"
      @visibleHandler="visibleHandler"
    />

    <surrendered-no-window
      :visible.sync="surrendered.visible"
      @visibleHandler="visibleHandler"
      @commit="doFdHandler"
    />
    <!-- 改单 -->
    <change-order-window
      :visible.sync="changeOrderDialog.visible"
      @close="changeOrderDialog.visible=false"
      @changeOrderHandler="changeOrderHandler"
    />
    <!-- 放单规则校验结果 -->
    <release-rule-result-window
      v-if="releaseRuleResultWindow.visible"
      :visible.sync="releaseRuleResultWindow.visible"
      :release-rules="releaseRuleResultWindow.releaseRules"
      :is-releasing="releaseRuleResultWindow.isReleasing"
      :data="releaseRuleResultWindow.data"
      @close="releaseRuleResultWindow.visible=false"
      @confirm="updateProperties"
    />
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import WithholdReasonWindow from '@/views/cargo/v0/Clearing/components/releaseControl/withholdReasonWindow'
import { getLoading } from '@/utils/utilBaseElement'
import { querySingleReleaseVerifyPageableFunc } from '@/api/seaExport/cargoDoc'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import statusChangeHistoryDialog from '@/components/Cargo/Job/statusChangeHistoryDialog'
import SurrenderedNoWindow from '@/views/cargo/v0/Clearing/components/releaseControl/surrenderedNoWindow'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { MBL } from '@/class/cargo/model/parameters/CargoDocConsts'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { DocumentManage } from '@/utils/commonUtil'
import DateUtils from '@/utils/dateUtils'
import { formatNumberToThousands } from '@/utils'
import $store from '@/store'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import ChangeOrderWindow from '@/views/cargo/v0/Clearing/components/releaseControl/changeOrderWindow'
import ReleaseRuleResultWindow from '@/views/cargo/v0/Clearing/components/releaseControl/releaseRuleResultWindow'
import moment from 'moment'
import { isNumber } from '@/utils/validate'
import { recordSelectedStatus } from '@/utils/agGrid'
import { cancelRequestRelease, requestRelease } from '@/api/seaExport/seaCargoDoc'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'

export default {
  name: 'SingleReleaseView',
  components: {
    ReleaseRuleResultWindow,
    ChangeOrderWindow,
    SurrenderedNoWindow,
    WithholdReasonWindow,
    searchItem,
    statusChangeHistoryDialog,
    cargoTemplateSelectorDialog
  },
  props: {
    arWriteOffStatusQuerySearch: { type: Boolean, default: false }, // 子应用应收核销状态查询条件/显示列
    arWriteOffStatusQueryColumn: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      documentManage: new DocumentManage(),
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      filterJson: {
        jobNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      filter: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      pageCount: 0,
      selectedData: null,
      selectedDataList: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 行点击事件
        onRowClicked: this.onRowClicked,
        // 行勾选事件
        onRowSelected: this.onRowSelected,
        defaultColDef: {
          resizable: true
        }
      },
      rowData: [],
      gridApi: null,
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'CargoDocList',
        data: {}
      },
      statusChangeHistoryDialog: {
        visible: false,
        uuid: ''
      },
      surrendered: {
        visible: false
      },
      changeOrderDialog: {
        visible: false
      },
      releaseRuleResultWindow: {
        visible: false,
        releaseRules: [],
        data: [],
        isReleasing: false
      },
      getBackFlag: true,
      cancelGetBackFlag: true
    }
  },
  computed: {
    customSearchItemsAuto() {
      return this.initCustomSearchItems()
    },
    columnDefs() {
      const columnDefs = [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobNo' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {},
              printMethod: this.showBusinessInfo
            }
          }
        },
        { headerName: this.$t('SeaExport.ConsignationCompany'), field: 'customerChineseName', width: 100, colId: 'customerChineseName' },
        { headerName: this.$t('CargoMsg.Cargo_AbbreviationOfConsignor'), field: 'customerShortName', width: 100, colId: 'customerShortName' },
        { headerName: this.$t('CargoMsg.Cargo_AccountPeriod'), field: 'creditPeriod', width: 100, colId: 'creditPeriod',
          cellRenderer: (params) => {
            return ColumnUtils.AccountPeriodCommonLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.AccountPeriodCommonLabelFunc(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CreditUsed'), field: 'creditUsed', width: 100, colId: 'creditUsed',
          cellRenderer: (params) => {
            return ColumnUtils.creditUsedCommonLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.creditUsedCommonLabelFunc(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BookingAgent'), field: 'bookingAgentChineseName', width: 100, colId: 'bookingAgentChineseName' },
        { headerName: this.$t('CargoMsg.Cargo_BookingAgentCode'), field: 'bookingAgentCnShortName', width: 100, colId: 'bookingAgentCnShortName' },
        { headerName: this.$t('CargoMsg.Cargo_BookingAgentAbbreviation'), field: 'bookingAgentShortName', width: 100, colId: 'bookingAgentShortName' },
        { headerName: this.$t('CargoMsg.Cargo_CarrierShip'), field: 'carrierChineseName', width: 100, colId: 'carrierChineseName' },
        { headerName: 'SO NO.', field: 'soNoStr', width: 100, colId: 'soNoStr',
          tooltipValueGetter: (params) => params.value
        },
        { headerName: this.$t('CargoMsg.Cargo_ShippingCompanySCode'), field: 'carrierCnShortName', width: 100, colId: 'carrierCnShortName' },
        { headerName: this.$t('CargoMsg.Cargo_ShippingCompanySAbbreviation'), field: 'carrierShortName', width: 100, colId: 'carrierShortName' },
        { headerName: this.$t('CargoMsg.Cargo_DestinationPort'), field: 'dischargingPortCode', width: 100, colId: 'dischargingPortCode',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ETD'), field: 'etd', width: 120, colId: 'etd',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ETA'), field: 'eta', width: 120, colId: 'eta',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ATA'), field: 'ata', width: 120, colId: 'ata',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'MB/L', field: 'mblNo', width: 100, colId: 'mblNo' },
        { headerName: 'HBL', field: 'hblInfo', width: 100, colId: 'hblInfo' },
        {
          headerName: this.$t('CargoMsg.Cargo_VesselAndVoyage'),
          field: 'voyageFlightStr',
          width: 100,
          colId: 'voyageFlightStr'
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessStatus'), field: 'jobState', width: 100, colId: 'jobState',
          cellRenderer: (params) => {
            return ColumnUtils.jobStateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.ReleasingStatus'), field: 'releaseState', width: 100, colId: 'releaseState',
          cellRenderer: params => {
            const releaseState = ReleaseState.getReleaseStateByCode(params.value)
            if (releaseState) {
              return this.$store.getters.language === 'zh' ? releaseState.chineseName : releaseState.englishName
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BLType'), field: 'docType', width: 100, colId: 'docType' },
        { headerName: this.$t('CargoMsg.Cargo_MBLMode'), field: 'releaseType', width: 100, colId: 'releaseType',
          cellRenderer: (params) => {
            return ColumnUtils.getHBLBillReleaseTypeByCode(BlModeType.MBL.code, params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CheckingStatus'), field: 'cfmState', width: 100, colId: 'cfmState',
          cellRenderer: (params) => {
            return ColumnUtils.cfmStatusLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BlReleasingNo'), field: 'surrenderedNo', width: 100, colId: 'surrenderedNo' },
        { headerName: this.$t('CargoMsg.Cargo_TelexReleaseApplicant'), field: 'surrenderedApplicant', width: 100, colId: 'surrenderedApplicant',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TelexReleaseApplicationDate'), field: 'surrenderedApplicationDate', width: 100, colId: 'surrenderedApplicationDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Sales'), field: 'sales', width: 100, colId: 'sales',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SalesDepartment'), field: 'salesDepartment', width: 100, colId: 'salesDepartment',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SalesBranchCompany'), field: 'salesOffice', width: 100, colId: 'salesOffice',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ReviewTime'), field: 'reviewDate', width: 100, colId: 'reviewDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TimeOfDocHolding'), field: 'withholdDate', width: 100, colId: 'withholdDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ReasonOfCargoDetention'),
          field: 'withholdReason',
          width: 100,
          colId: 'withholdReason'
        },
        { headerName: this.$t('CargoMsg.Cargo_2NdReleaseTime'), field: 'secondReleaseDate', width: 100, colId: 'secondReleaseDate',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remarks', width: 100, colId: 'remarks' },
        { headerName: this.$t('CargoMsg.Cargo_Operation'), field: 'op', width: 100, colId: 'op',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CustomerService'), field: 'csr', width: 100, colId: 'csr',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Documents'), field: 'dc', width: 100, colId: 'dc',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ReleasePerson'), field: 'releaseBy', width: 100, colId: 'releaseBy',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Auditor'), field: 'releaseReviewUser', width: 100, colId: 'releaseReviewUser',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: 'ATD', field: 'atd', width: 100, colId: 'atd',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_StatusUpdateUser'), field: 'cfmStateUser', width: 100, colId: 'cfmStateUser',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_StatusUpdateTime'), field: 'cfmStateDate', width: 100, colId: 'cfmStateDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.BillLadingIssued'), field: 'bliStatus', width: 100, colId: 'bliStatus',
          cellRenderer: (params) => {
            return ColumnUtils.bliStatusLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ReceivingOperator'), field: 'receivedOperator', width: 100, colId: 'receivedOperator',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_ReceivingOperationTime'), field: 'receivedDate', width: 100, colId: 'receivedDate' },
        { headerName: this.$t('CargoMsg.Cargo_ClaimOperator'), field: 'claimOperator', width: 100, colId: 'claimOperator',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_ClaimOperationTime'), field: 'claimDate', width: 100, colId: 'claimDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_OrderChangeOperator'), hide: true, field: 'orderChangeOperator', width: 100, colId: 'orderChangeOperator',
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_ChangeOrderOperationTime'), hide: true, field: 'changeOrderOperationTime', width: 100, colId: 'changeOrderOperationTime',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ExpectedReturnDate'), hide: true, field: 'estimatedDeliveryDate', width: 100, colId: 'estimatedDeliveryDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('SeaExport.ReleasingDate'), field: 'releaseDate', width: 120, colId: 'releaseDate', hide: true,
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessReferenceNo'),
          field: 'customerRefNo',
          width: 200
        },
        { headerName: this.$t('SeaExport.RequestReleaseState'), field: 'requestReleaseState', width: 120, colId: 'requestReleaseState',
          cellRenderer: params => {
            return params.value === 0 ? this.$t('SeaExport.NotApplying') : this.$t('SeaExport.Requested')
          }
        },
        { headerName: this.$t('SeaExport.RequestReleaseDate'), field: 'requestReleaseTime', width: 120, colId: 'requestReleaseTime',
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.RequestReleaseBy'), field: 'requestReleaseBy', width: 120, colId: 'requestReleaseBy',
          cellRenderer: params => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.NCReferenceNo'),
          field: 'agentRefNo',
          colId: 'agentRefNo',
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'exChangeAgent',
          colId: 'exChangeAgent',
          hide: true,
          enableRowGroup: true,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomizedField1'),
          field: 'userDefinedField1',
          colId: 'userDefinedField1',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomizedField2'),
          field: 'userDefinedField2',
          colId: 'userDefinedField2',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomizedField3'),
          field: 'userDefinedField3',
          colId: 'userDefinedField3',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomizedField4'),
          field: 'userDefinedField4',
          colId: 'userDefinedField4',
          hide: true,
          width: 150
        }
      ]
      if (this.arWriteOffStatusQueryColumn) {
        columnDefs.push({ headerName: this.$t('CargoMsg.Cargo_ReceivablesWriteOfStatus'), field: 'verifyStateReceivable', colId: 'verifyStateReceivable', width: 150 })
      }
      return columnDefs
    }
  },
  watch: {
    'selectedDataList': {
      handler(params) {
        if (params) {
          // 当提单签发状态=已取回/已接收/已认领 时禁止 操作取回按钮
          this.getBackFlag = params.some(val =>
            val.bliStatus === CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code ||
            val.bliStatus === CargoDocCfmState.CARGODOC_CFM_STATE_RECEIVED.code ||
            val.bliStatus === CargoDocCfmState.CARGODOC_CFM_STATE_CLAIMED.code)
          // 当提单签发状态=已取回 时可点击“撤销取回”按钮（其他状态禁止撤销取回）
          this.cancelGetBackFlag = params.some(val => val.bliStatus !== CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code)
        }
      }
    }
  },
  async created() {
    await this.preloadBasicData()
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    // this.initCustomSearchItems()
  },
  beforeMount() {
    this.documentManage.set('showBusinessInfo', () => {
      this.showBusinessInfo()
    })
  },
  beforeDestroy() {

  },
  methods: {
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    onGridReady(p) {
      this.gridApi = p.api
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.jobNo = keyword.trim()
      this.filterJson.conditions = []
      this.doAdvancedQuery()
    },
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.jobNo = ''
      }
      this.doAdvancedQuery(data)
    },
    // 高级查询
    doAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', this.filterJson.conditions)) {
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', [0, 1, 2, 11, 13], AdvancedSearchConsts.OPERATOR_IN.code)
        this.filterJson.conditions.push(option.formatObj2Json())
      }
      const conditionMap = {}
      let expectDateOption = {}
      // 是否已核销
      if (AdvancedSearchOption.hasField('charge.paidOff', this.filterJson.conditions)) {
        expectDateOption = AdvancedSearchOption.getOption('charge.paidOff', this.filterJson.conditions)
        conditionMap['paidOff'] = expectDateOption.value
        AdvancedSearchOption.removeOption('charge.paidOff', this.filterJson.conditions)
      }
      // 是否全部核销
      if (AdvancedSearchOption.hasField('isWriteOffAll', this.filterJson.conditions)) {
        expectDateOption = AdvancedSearchOption.getOption('isWriteOffAll', this.filterJson.conditions)
        conditionMap['isWriteOffAll'] = expectDateOption.value
        AdvancedSearchOption.removeOption('isWriteOffAll', this.filterJson.conditions)
      }
      conditionMap['docType'] = MBL
      this.filterJson.page = 2
      this.filterJson.condition = conditionMap
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.requires = this.arWriteOffStatusQueryColumn ? ['verifyStateReceivable'] : []
      querySingleReleaseVerifyPageableFunc(this.filterJson).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    setVoyageFlight(data) {
      if (data.vessel && data.voyageFlight) {
        return data.vessel + '/' + data.voyageFlight
      } else if (data.vessel) {
        return data.vessel
      } else if (data.voyageFlight) {
        return data.voyageFlight
      } else {
        return ''
      }
    },
    setSoNo(data) {
      let v = data.soNo
      if (data.soNo && data.soNo.indexOf('\n') !== -1) {
        const n = data.soNo.split('\n')
        v = n[0] + '...'
      }
      return v
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      if (res.data.list) {
        for (const data of res.data.list) {
          CargoDocUtil.setFieldHandler(data)
        }
      }
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.pageCount = res.data.pages
      this.selectedData = null
      this.gridApi.clearFocusedCell()
      this.loading.close()
      selectedStatus.revert()
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) {
        this.selectedData = node
      }
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedData = {}
      if (this.gridApi) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            const f = node.data
            if (f.uuid) {
              this.selectedData = f
            }
          }
        })
      }
    },
    // 取回
    async btnGetBackEventHandler() {
      const selectedList = this.getSelectedItems()
      if (!selectedList) {
        return
      }
      const obj = {}
      const docList = []
      for (const d of selectedList) {
        obj['bliStatus'] = CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code
        obj['getBackDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        obj['operation'] = CargoDocCfmState.CARGODOC_GET_BACK
        docList.push(d.uuid)
      }
      await this.btnEventOperate(this.$t('CargoMsg.Cargo_GetBack'), docList, obj)
    },
    // 撤销取回
    async btnCancelGetBackEventHandler() {
      const selectedList = this.getStateValidSelection(CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code, this.$t('CargoMsg.Cargo_CancelGetBack'), 'bliStatus')
      if (!selectedList) {
        return
      }
      const obj = {}
      const docList = []
      for (const d of selectedList) {
        obj['bliStatus'] = CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code
        obj['getBackDate'] = ''
        obj['operation'] = CargoDocCfmState.CARGODOC_CANCEL_GET_BACK
        docList.push(d.uuid)
      }
      await this.btnEventOperate(this.$t('CargoMsg.Cargo_CancelGetBack'), docList, obj)
    },
    // 接收
    async btnReceivedEventHandler() {
      const selectedList = this.getSelectedItems()
      if (!selectedList) {
        return
      }
      const obj = {}
      const docList = []
      for (const d of selectedList) {
        obj['bliStatus'] = CargoDocCfmState.CARGODOC_CFM_STATE_RECEIVED.code
        obj['receivedDate'] = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        obj['operation'] = CargoDocCfmState.CARGODOC_RECEIVED
        obj['receivedOperator'] = $store.getters.userId
        docList.push(d.uuid)
      }
      await this.btnEventOperate(this.$t('CargoMsg.Cargo_Receive'), docList, obj)
    },
    // 撤销接收
    async btnCancelReceivedEventHandler() {
      const selectedList = this.getStateValidSelection(CargoDocCfmState.CARGODOC_CFM_STATE_RECEIVED.code, this.$t('CargoMsg.Cargo_RevocationOfReceipt'), 'bliStatus')
      if (!selectedList) {
        return
      }
      const obj = {}
      const docList = []
      for (const d of selectedList) {
        obj['bliStatus'] = CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code
        obj['receivedDate'] = ''
        obj['operation'] = CargoDocCfmState.CARGODOC_CANCEL_RECEIVED
        obj['receivedOperator'] = 0
        docList.push(d.uuid)
      }
      await this.btnEventOperate(this.$t('CargoMsg.Cargo_RevocationOfReceipt'), docList, obj)
    },
    // 认领
    async btnClaimEventHandler() {
      const selectedList = this.getSelectedItems()
      if (!selectedList) {
        return
      }
      const obj = {}
      const docList = []
      for (const d of selectedList) {
        obj['bliStatus'] = CargoDocCfmState.CARGODOC_CFM_STATE_CLAIMED.code
        obj['claimDate'] = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        obj['operation'] = CargoDocCfmState.CARGODOC_CLAIMED
        obj['claimOperator'] = $store.getters.userId
        docList.push(d.uuid)
      }
      await this.btnEventOperate(this.$t('CargoMsg.Cargo_Claim'), docList, obj)
    },
    // 撤销认领
    async btnCancelClaimEventHandler() {
      const selectedList = this.getStateValidSelection(CargoDocCfmState.CARGODOC_CFM_STATE_CLAIMED.code, this.$t('CargoMsg.Cargo_RevokeClaim'), 'bliStatus')
      if (!selectedList) {
        return
      }
      const obj = {}
      const docList = []
      for (const d of selectedList) {
        obj['bliStatus'] = CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code
        obj['claimDate'] = ''
        obj['claimOperator'] = 0
        obj['operation'] = CargoDocCfmState.CARGODOC_CANCEL_CLAIMED
        docList.push(d.uuid)
      }
      await this.btnEventOperate(this.$t('CargoMsg.Cargo_RevokeClaim'), docList, obj)
    },
    // 放单
    async btnFdEventHandler() {
      const selectedList = this.getValidSelection(ReleaseState.SINGLERELEASE.code, this.$t('CargoMsg.Cargo_Releasing'))
      if (!selectedList) {
        return
      }
      this.$confirm(this.$t('Message.AreYouSureYouWantTo', [this.$t('CargoMsg.Cargo_Releasing')]), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(async() => {
        this.surrendered.visible = true
      })
    },
    async doFdHandler(event) {
      const selectedList = this.getValidSelection(ReleaseState.SINGLERELEASE.code, this.$t('CargoMsg.Cargo_Releasing'))
      if (!selectedList) {
        return
      }
      const obj = {}
      const docList = []
      for (const d of selectedList) {
        // obj['cfmState'] = CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code
        obj['releaseDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        obj['operation'] = CargoDocCfmState.CARGODOC_RETURN
        obj['releaseBy'] = $store.getters.userId
        obj['surrenderedNo'] = event.surrenderedNo
        obj['releaseState'] = ReleaseState.ONSINGLERELEASE.code
        docList.push(d.uuid)
      }
      await this.updateProperties(docList, obj)
    },
    // 撤销放单
    async btnCancelFdEventHandler() {
      const selectedList = this.getStateValidSelection(ReleaseState.ONSINGLERELEASE.code, this.$t('SeaExport.CancelReleasing'), 'releaseState')
      if (!selectedList) {
        return
      }
      const obj = {}
      const docList = []
      for (const d of selectedList) {
        obj['cfmState'] = CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code
        obj['releaseState'] = ReleaseState.SINGLERELEASE.code
        obj['releaseDate'] = ''
        obj['releaseBy'] = 0
        obj['operation'] = CargoDocCfmState.CARGODOC_CANCEL_RETURN
        obj['surrenderedNo'] = ''
        docList.push(d.uuid)
      }
      await this.btnEventOperate(this.$t('SeaExport.CancelReleasing'), docList, obj)
    },
    getSelectedItems() {
      const items = this.gridApi.getSelectedRows()
      if (items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoRecordSelected'))
        return
      }
      const result = []
      for (const doc of items) {
        if (doc.cfmState !== CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code) {
          result.push(doc)
        }
      }
      return result
    },
    // 按状态过滤doc
    getStateValidSelection(state, action, stateField = 'cfmState') {
      const items = this.gridApi.getSelectedRows()
      const result = []
      if (items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoRecordSelected'))
        return
      }
      for (const doc of items) {
        if (doc[stateField] === state) {
          result.push(doc)
        }
      }
      if (result.length === 0) {
        this.$message.warning(this.$t('Message.NoRecordsAvailable', [action]))
        return
      }
      return result
    },
    // 按状态过滤doc
    getValidSelection(state, action) {
      const items = this.gridApi.getSelectedRows()
      const result = []
      if (items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoRecordSelected'))
        return
      }
      for (const doc of items) {
        if (doc.releaseState === state) {
          result.push(doc)
        }
      }
      if (result.length === 0) {
        this.$message.warning(this.$t('Message.NoRecordsAvailable', [action]))
        return
      }
      return result
    },
    // 更新提单数据
    btnEventOperate(operateName, docList, obj) {
      if (docList.length > 0) {
        this.$confirm(this.$t('Message.AreYouSureYouWantTo', [operateName]), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.yes'),
          cancelButtonText: this.$t('common.btn.no'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(async() => {
          await this.updateProperties(docList, obj)
        })
      }
    },
    // 刷新列表
    refreshList(docList, map) {
      if (!docList) {
        return
      }
      for (const d of docList) {
        const index = this.rowData.findIndex(row => {
          return row.uuid === d
        })
        const rowData = this.rowData
        const obj = map[rowData[index].uuid]
        Object.keys(obj).forEach((key) => {
          rowData[index][key] = (isNumber(rowData[index][key]) ? Number(obj[key]) : obj[key])
        })
        this.rowData = [...rowData]
      }
    },
    // 打印
    btnPrintEventHandler() {
      if (!this.selectedData) {
        this.$message.warning(this.$t('Message.ReleaseInformationNotSelected'))
        return
      }
      const doc = this.selectedData
      const params = {}
      params.jobuuid = doc.jobUuid
      params.cargoDocUuid = doc.uuid
      params.DOC_UUID = doc.uuid
      this.templateSelectorDialog.category = doc.docType
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    // 提单日志管理
    btnStatusHistoryEventHandler() {
      if (!this.selectedData || !this.selectedData.uuid) {
        this.$message.warning(this.$t('Message.ReleaseInformationNotSelected'))
        return
      }
      this.statusChangeHistoryDialog.visible = true
      this.statusChangeHistoryDialog.uuid = this.selectedData.uuid
    },
    showBusinessInfo(e) {
      if (!this.selectedData) return
      this.templateSelectorDialog.ctx = new SeaExportJob(this.selectedData)
      this.templateSelectorDialog.category = 'JOB_DETAIL'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedData.jobUuid }
      this.templateSelectorDialog.visible = true
    },
    async visibleHandler() {
      this.surrendered.visible = false
      this.statusChangeHistoryDialog.visible = false
    },
    initCustomSearchItems() {
      this.customSearchItems = ColumnUtils.getBlModeList(BlModeType.MBL.code)
      if (this.arWriteOffStatusQuerySearch) {
        const searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'job._JOB_PAIDOFF_TRUE_'
        searchField.itemLabel = 'CargoMsg.Cargo_ReceivablesWriteOfStatus'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = 'SystemConstants.RECEIVABLE'
        searchField.dataCacheKey = 'local_cache_SystemConstants$RECEIVABLE'
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        this.customSearchItems.push(searchField.formatObj2Json())
      }
      this.searchItemAutoInit = true
      return this.customSearchItems
    },
    // 改单
    btnChangeOrderEventHandler() {
      if (!this.selectedData) {
        this.$message.warning(this.$t('Message.ReleaseInformationNotSelected'))
        return
      }
      this.changeOrderDialog.visible = true
    },
    async changeOrderHandler(estimatedDeliveryDate) {
      const obj = {}
      const docList = []
      const data = this.selectedData
      obj['changeOrderOperationTime'] = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      obj['orderChangeOperator'] = $store.getters.userId
      obj['estimatedDeliveryDate'] = estimatedDeliveryDate
      obj['bliStatus'] = CargoDocCfmState.CARGODOC_BLI_STATUS_CHANGE.code
      obj['operation'] = CargoDocCfmState.CARGODOC_CHANGE
      docList.push(data.uuid)
      await this.updateProperties(docList, obj)
    },
    async updateProperties(docList, obj) {
      const result = await SeaCargoDoc.updateProperties(docList, obj)
      if (result.seaCargoDocs && result.seaCargoDocs.length > 0) {
        this.$message.success(this.$t('Message.StateModifiedSuccessfully'))
        // 刷新列表
        this.refreshList(docList, result.updateStateMap)
      }
      if (result.releaseRules && result.releaseRules.length > 0) {
        this.releaseRuleResultWindow.visible = true
        this.releaseRuleResultWindow.releaseRules = result.releaseRules
        // 处理放单逻辑
        const isReleasing = (obj.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code)
        this.releaseRuleResultWindow.isReleasing = isReleasing
        if (isReleasing) {
          // 待收款
          this.releaseRuleResultWindow.data = docList.filter(key => result.updateStateMap[key].releaseState === ReleaseState.TO_BE_COLLECTED.code + '')
        }
        return
      }
    },
    printedCallback(data) {
      if (data && data.template && data.parameter && data.template.name && data.template.name.indexOf('提单确认件') >= 0 && data.parameter.cargoDocUuid) {
        const map = {}
        const uuid = decodeURIComponent(data.parameter.cargoDocUuid)
        map[uuid] = { cfmState: 11 }
        this.refreshList([uuid], map) // 提单确认中
      }
    },
    btnRequestReleaseEventHandler() {
      const { uuids } = this.getRequestReleaseData(0)
      if (!uuids || uuids.length === 0) {
        return
      }
      this.loading = getLoading()
      requestRelease(uuids).then(res => {
        this.loading.close()
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.refreshList(uuids, res.data)
      }).catch(() => {
        this.loading.close()
      })
    },
    btnCancelRequestReleaseEventHandler() {
      const { uuids } = this.getRequestReleaseData(1)
      if (!uuids || uuids.length === 0) {
        return
      }
      this.loading = getLoading()
      cancelRequestRelease(uuids).then(res => {
        this.loading.close()
        this.$message.success(this.$t('Message.OperationSuccessfully'))
        this.refreshList(uuids, res.data)
      }).catch(() => {
        this.loading.close()
      })
    },
    getRequestReleaseData(state) {
      const items = this.gridApi.getSelectedRows()
      const uuids = []
      if (items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoRecordSelected'))
        return {}
      }
      for (const doc of items) {
        if (doc.requestReleaseState === state) {
          uuids.push(doc.uuid)
        }
      }
      if (uuids.length === 0) {
        this.$message.warning(state === 0 ? this.$t('SeaExport.NoRequestReleaseData')
          : this.$t('SeaExport.NoCancelRequestReleaseData'))
        return {}
      }
      return { uuids }
    }
  }
}
</script>

<style lang="scss">
#app #verify-tree-grid {
  .ag-theme-balham {
    .ag-row-hover {
      background: #9bddff !important;
    }
    .ag-row-focus {
      background: #6abdff !important;
    }
  }
  .main-inner-row {
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .query-input-spacing {
    padding-right: 10px;
  }
}
</style>
